var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { staticClass: "d-in-block" },
        [
          _c(
            "yxtf-button",
            {
              attrs: { plain: "", loading: _vm.prevLoading },
              on: { click: _vm.handlePrevClick },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_o2o_btn_before_task")))]
          ),
          _c(
            "yxtf-button",
            {
              attrs: { type: "primary", loading: _vm.nextLoading },
              on: { click: _vm.handleNextClick },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_o2o_btn_next_task")))]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }